/**
 * Profile API
 * User profile management operations
 */

import apiClient from '@/lib/api-client'
import type { User, UserProfileUpdate, UserPasswordChange } from '@/types/user'

export const profileApi = {
  /**
   * Get current user profile
   */
  async getMyProfile(): Promise<User> {
    const response = await apiClient.get<User>('/profile/me')
    return response.data
  },

  /**
   * Update current user profile
   */
  async updateMyProfile(data: UserProfileUpdate): Promise<User> {
    const response = await apiClient.put<User>('/profile/me', data)
    return response.data
  },

  /**
   * Change password
   */
  async changePassword(data: UserPasswordChange): Promise<{ message: string }> {
    const response = await apiClient.post<{ message: string }>(
      '/profile/me/password',
      data
    )
    return response.data
  },

  /**
   * Upload profile picture
   */
  async uploadAvatar(file: File): Promise<{ message: string; profile_picture_url: string }> {
    const formData = new FormData()
    formData.append('file', file)

    const response = await apiClient.post<{ message: string; profile_picture_url: string }>(
      '/profile/me/avatar',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    return response.data
  },

  /**
   * Remove profile picture
   */
  async removeAvatar(): Promise<{ message: string; profile_picture_url: string }> {
    const response = await apiClient.delete<{ message: string; profile_picture_url: string }>(
      '/profile/me/avatar'
    )
    return response.data
  },
}

export default profileApi
